export const DraggableItemTypes = {
    BLOCK: 'block',
};
